import type { SVGProps } from "react";
export interface EmailShieldIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function EmailShieldIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: EmailShieldIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 11.215V5c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v10c0 1.036.84 1.875 1.875 1.875h6l.116.006a1.125 1.125 0 0 1 0 2.239l-.116.005H5a4.125 4.125 0 0 1-4.125-4.124V5A4.125 4.125 0 0 1 5 .875h14A4.125 4.125 0 0 1 23.125 5v6.215a1.125 1.125 0 1 1-2.25 0"
      />
      <path
        fill={color}
        d="M20.875 16.385 18.5 15.197l-2.375 1.188v1.737l.015.169c.07.407.389.907.977 1.451.472.436 1 .794 1.383 1.027.383-.233.911-.59 1.383-1.027.672-.621.992-1.187.992-1.62zm0-11.385c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v.318c0 .319.174.612.453.766l7.519 4.135.215.101c.515.204 1.1.17 1.592-.1l7.518-4.136.1-.064a.87.87 0 0 0 .353-.702zm2.25 13.122-.01.264c-.107 1.297-.976 2.334-1.704 3.007a11.2 11.2 0 0 1-1.75 1.302l-.395.23a1.57 1.57 0 0 1-1.349.088l-.183-.088c-.417-.231-1.327-.774-2.146-1.532-.728-.673-1.596-1.71-1.702-3.007l-.01-.264V16c0-.615.347-1.179.897-1.454l3-1.5.175-.075a1.63 1.63 0 0 1 1.104 0l.175.075 3 1.5.196.117c.435.3.702.799.702 1.337v2.123Zm0-12.804c0 1.14-.62 2.189-1.62 2.738l-7.517 4.135a4.13 4.13 0 0 1-3.975 0l-7.52-4.135A3.13 3.13 0 0 1 .876 5.318V5A4.125 4.125 0 0 1 5 .875h14A4.125 4.125 0 0 1 23.125 5z"
      />
    </svg>
  );
}
